module.exports = __webpack_public_path__ + "img/casos-exito3.83de94a0.png";